/* eslint-disable @typescript-eslint/naming-convention */
import { OdataAttribute } from './odata-attribute.type';

export const ATTR_OBJECTTYPEID: OdataAttribute = {
  name: 'ObjectTypeId',
  type: 'Edm.Guid',
};

export const ATTR_PARENTOBJECTTYPEID: OdataAttribute = {
  name: 'ParentObjectTypeId',
  type: 'Edm.Guid',
};

export const ATTR_DATECREATED: OdataAttribute = {
  name: 'DateCreated',
  type: 'Edm.DateTimeOffset',
};

export const ATTR_CREATEDBYID: OdataAttribute = {
  name: 'CreatedById',
  type: 'Edm.Guid',
};

export const ATTR_DATELASTMODIFIED: OdataAttribute = {
  name: 'DateLastModified',
  type: 'Edm.DateTimeOffset',
};

export const ATTR_LASTMODIFIEDBYID: OdataAttribute = {
  name: 'LastModifiedById',
  type: 'Edm.Guid',
};

export const ATTR_ACTIVESTATE: OdataAttribute = {
  name: 'ActiveState',
  type: 'Edm.Boolean',
};

export const ATTR_ISAPPROVABLE: OdataAttribute = {
  name: 'IsApprovable',
  type: 'Edm.Boolean',
};

export const ATTR_ALIAS: OdataAttribute = {
  name: 'Alias',
  type: 'Edm.String',
};

export const ATTR_NAME: OdataAttribute = {
  name: 'Name',
  type: 'Edm.String',
};

export const ATTR_DESCRIPTION: OdataAttribute = {
  name: 'Description',
  type: 'Edm.String',
};

export interface Gen_ObjectType {
  ObjectTypeId: string;
  ParentObjectTypeId: string;
  DateCreated: string;
  CreatedById: string;
  DateLastModified: string;
  LastModifiedById: string;
  ActiveState: boolean;
  IsApprovable: boolean;
  Alias: string;
  Name: string;
  Description: string;
}
